<template>
  <div id="crossings-row">
    <div class="flex row justify-space-between">
      <div class="flex row">
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" class="icon">
          <circle class="circle6" cx="11.5" cy="11.5" r="11.5"/>
        </svg>
        <p class="text">{{ date }}</p>
      </div>
      <p class="text">{{ hour }}</p>
    </div>
    <div class="description">
      <p class="text">{{ description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CrossingsRow',
  props: {
    crossing: {
      type: Object,
      required: true
    }
  },
  computed: {
    date () {
      return this.crossing.crossing_date.split('T')[0]
    },
    hour () {
      const fullHour = this.crossing.crossing_date.split('T')[1]
      return fullHour.split('.')[0]
    },
    description () {
      return `${this.crossing.vehicle_reference} realizó un cruce. Saldo Anterior: ${this.crossing.previous_balance}, Saldo después del cruce: ${this.crossing.current_balance}`
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

#crossings-row {
  margin-bottom: 2rem;
}

.icon {
  fill: #4d47ff;
  align-self: center;
  margin-right: 1rem;
}

.text {
  margin: .25rem 0;
}

.description {
  background-color: white;
  text-align: left;
  padding: .25rem 1rem;
  border-radius: 40px;
}
</style>
